module.exports = __webpack_public_path__ + "static/media/Eye.e32e3684.svg";